<template>
  <a-modal v-model="modal" title="新建" width="560px" :maskClosable="false" :closable="false">
    <div class="create-material" v-if="modal">
      <a-form-model :model="formData" ref="form">
        <a-form-model-item
          label="父级工作中心"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="parentCode"
        >
          <global-select
            searchParam="centerCode"
            selectType="selectAssembleSearch"
            :value.sync="formData.parentCode"
            requestApi="/bom/workCenter/list"
            :selectItem="{ value: 'centerCode', label: 'centerName' }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="加工组织"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="organizationCode"
          :rules="rules.organizationCode"
        >
          <global-select
            v-model="formData.organizationCode"
            v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
            selectType="selectAssemble"
            :selectData="inventOrg"
            :disabled="isDisableOrganization"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :assembleLabel="true"
            @change="inventOrgValueOnChange"
          />
        </a-form-model-item>
        <a-form-model-item
          label="工作中心编码"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="centerCode"
          :rules="rules.centerCode"
        >
          <a-input v-model="formData.centerCode" placeholder="请输入" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item
          label="工作中心名称"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="centerName"
          :rules="rules.centerCode"
        >
          <a-input v-model="formData.centerName" placeholder="请输入" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item
          label="工作中心类别"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="centerCategory"
          :rules="rules.centerCategory"
        >
          <global-select
            :value.sync="formData.centerCategory"
            :selectData="centerCategoryList"
            selectType="selectFilter"
            :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="所属车间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="workshopCode"
          :rules="rules.workshopCode"
        >
          <global-select
            :value.sync="formData.workshopCode"
            :selectData="workshopList"
            selectType="selectAssembleFilter"
            :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="供应子库"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="supplySublibrary"
        >
          <global-select
            searchParam="warehouseCode"
            selectType="selectAssembleSearch"
            :value.sync="formData.supplySublibrary"
            requestApi="/inv/invCallRequestLines/intoSublibraryBox"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :setParams="{ 'organizationCode': formData.organizationCode }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="完工子库"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="completedSublibrary"
        >
          <global-select
            searchParam="warehouseCode"
            selectType="selectAssembleSearch"
            :value.sync="formData.completedSublibrary"
            requestApi="/inv/invCallRequestLines/intoSublibraryBox"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :setParams="{ 'organizationCode': formData.organizationCode }"
            @change="handleCompletedSublibraryChange"
          />
        </a-form-model-item>
        <a-form-model-item
          label="完工货位"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="completedLocation"
        >
          <global-select
            searchParam="locationCode"
            selectType="selectSearch"
            :value.sync="formData.completedLocation"
            requestApi="/inv/invCallRequestLines/intoGoodsAllocationBox"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :setParams="{ 'subinventoryCode': formData.completedSublibrary }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="备注"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="remark"
        >
          <a-input v-model="formData.remark" placeholder="请输入" :maxLength="100" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment';

import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'
import { apiBomWorkshopFindList } from '@/api/mes/productionPrepare/attributeMaintenance'
import { apiWorkCenterUpdate } from '@/api/mes/productionPrepare/workCenter'

export default {
  name: 'CreateModal',
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  created() {
    this.cacheLookupRequest('WORK_CENTER_TYPE', { lookupType: 'WORK_CENTER_TYPE', current: 1, pageSize: 999 }, 'centerCategoryList')
    apiBomWorkshopFindList({
      workshopStatus: "Y",
      organizationCode: this.organizationCodeOrigin
    }).then(res => {
      if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
    });
  },
  data() {
    return {
      modal: false,
      formData: {
        parentCode: '',
        organizationCode: '', //  组织
        centerCode: '', // 工作中心编码
        centerName: '', // 工作中心名称
        centerCategory: '', // 工作中心类别
        workshopCode: '', // 所属车间
        supplySublibrary: '', // 供应子库
        completedSublibrary: '', // 完工子库
        completedLocation: '', // 完工库位
        remark: '' // 备注
      },
      loading: false,
      rules: {
        organizationCode: [{ required: true, message: ' ', trigger: 'change' }],
        workshopCode: [{ required: true, message: ' ', trigger: 'change' }],
        centerCode: [{ required: true, message: ' ', trigger: 'change' }],
        centerName: [{ required: true, message: ' ', trigger: 'change' }],
        centerCategory: [{ required: true, message: ' ', trigger: 'change' }]
      },
      centerCategoryList: [], // 工作中心类别列表
      workshopList: [], // 车间列表
      centerList: [] // 工作中心列表
    }
  },
  methods: {
    moment,
    // 初始化
    show () {
      this.$set(this.formData, 'organizationCode', this.organizationCodeOrigin)
      this.$set(this.formData, 'workshopCode', '')
      this.$set(this.formData, 'centerCode', '')
      this.$set(this.formData, 'centerName', '')
      this.$set(this.formData, 'parentCode', '')
      this.$set(this.formData, 'centerCategory', '')
      this.$set(this.formData, 'supplySublibrary', '')
      this.$set(this.formData, 'completedSublibrary', '')
      this.$set(this.formData, 'completedLocation', '')
      this.$set(this.formData, 'remark', '')
      this.modal = true
    },
    // 子库变化
    handleCompletedSublibraryChange() {
      this.formData.completedLocation = ''; // 变化完工子库时，清空完工库位
    },
    // 确认创建
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          apiWorkCenterUpdate(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('创建成功')
              this.$emit("refresh")
              this.modal = false
            } else {
              this.$message.error(res?.msg || '创建失败')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 加工组织
    inventOrgValueOnChange (val, status) {
      this.formData.workshopCode = '';
      apiBomWorkshopFindList({ organizationCode: val, workshopStatus: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
      })
      this.formData.supplySublibrary = '';
      this.formData.completedSublibrary = '';
      this.formData.completedLocation = '';
    }
  }
}
</script>

<style lang="less" scoped></style>
